import { Filial } from "../filial/filial";
import { Medico } from "./medico";
import { MedicoFilialPk } from "./pks/medico-filial-pk";

export class MedicoFilial {

    pk: MedicoFilialPk = new MedicoFilialPk();

    medico: Medico = new Medico();

    filial: Filial = new Filial();

    constructor() {
    }
}
